import {
  FraudEventTypes as FraudEventTypesEnum,
  FraudPolicies,
  FraudRuleEntities as FraudDetectionEntitiesEnum,
  FraudRuleTypes,
  FraudStatus
} from "@upmind-automation/types";

import i18n from "@/i18n";

const FraudTypes = () => {
  return [
    {
      id: FraudRuleTypes.COUNTRY,
      label: i18n.t("_.country").toString()
    },
    { id: FraudRuleTypes.IP, label: i18n.t("_.ip").toString() }
  ];
};

const FraudEntities = () => {
  return [
    {
      id: FraudDetectionEntitiesEnum.ORGANISATION,
      label: i18n.t("_.organisation")
    },
    { id: FraudDetectionEntitiesEnum.BRAND, label: i18n.t("_.brand") }
  ];
};

const FraudLevels = () => {
  return [
    {
      id: 1,
      label: i18n.t("_.allow"),
      desc: i18n.t("_sentence.fraud.allow_rule_desc")
    },
    {
      id: 2,
      label: i18n.t("_.review"),
      desc: i18n.t("_sentence.fraud.review_rule_desc")
    },
    {
      id: 3,
      label: i18n.t("_.block"),
      desc: i18n.t("_sentence.fraud.block_rule_desc")
    }
  ];
};

const FraudEventTypes = () => {
  return Object.keys(FraudEventTypesEnum)
    .filter(
      key =>
        isNaN(Number(key)) &&
        FraudEventTypesEnum[key as keyof typeof FraudEventTypesEnum] !==
          undefined
    )
    .map(key => {
      const id = FraudEventTypesEnum[key as keyof typeof FraudEventTypesEnum];
      return {
        id,
        label: i18n.t(`_.fraud_reasons.${key.toLowerCase()}`),
        eventDescPath: `_sentence.fraud_events.${key.toLowerCase()}`
      };
    });
};

const FraudStatusMap = () => {
  return {
    [FraudStatus.NOT_FRAUD]: {
      id: FraudStatus.NOT_FRAUD,
      label: i18n.t("_.approved"),
      desc: object =>
        i18n.t("_sentence.fraud_status_approved_desc", { object }),
      type: "is-success",
      icon: "check-circle",
      class: "has-text-success"
    },
    [FraudStatus.REVIEW]: {
      id: FraudStatus.REVIEW,
      label: i18n.t("_.review"),
      desc: object => i18n.t("_sentence.fraud_status_review_desc", { object }),
      type: "is-warning",
      icon: "exclamation-circle",
      class: "has-text-warning"
    },
    [FraudStatus.FRAUD]: {
      id: FraudStatus.FRAUD,
      label: i18n.t("_.blocked"),
      desc: object => i18n.t("_sentence.fraud_status_blocked_desc", { object }),
      type: "is-danger",
      icon: "ban",
      class: "has-text-danger"
    }
  };
};

const FraudPoliciesMap = () => {
  return {
    [FraudPolicies.NEUTRAL]: {
      id: FraudPolicies.NEUTRAL,
      desc: i18n.t("_sentence.fraud_policy_neutral_desc"),
      order: 1
    },
    [FraudPolicies.REVIEW]: {
      id: FraudPolicies.REVIEW,
      desc: i18n.t("_sentence.fraud_policy_review_desc"),
      order: 2
    },
    [FraudPolicies.WHITELIST]: {
      id: FraudPolicies.WHITELIST,
      desc: i18n.t("_sentence.fraud_policy_whitelist_desc"),
      order: 3
    }
  };
};

export {
  FraudStatus,
  FraudPolicies,
  FraudRuleTypes,
  FraudEntities,
  FraudLevels,
  FraudTypes,
  FraudEventTypes,
  FraudPoliciesMap,
  FraudStatusMap
};
